export default __webpack_public_path__ + "static/media/folder_mask.7815e241.svg";